import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100 px-3 px-lg-0 d-flex flex-column flex-md-row align-items-center align-items-md-start justify-content-between" }
const _hoisted_2 = { class: "h-100 d-none flex-column d-lg-flex mb-2 mb-lg-0 position-relative flex-item align-items-center" }
const _hoisted_3 = { class: "flex-item-container d-flex flex-column" }
const _hoisted_4 = { class: "body-strong text-primary-blue text-start" }
const _hoisted_5 = { class: "d-flex flex-column d-lg-flex text-start body text-grey-900 mb-2 me-1" }
const _hoisted_6 = { class: "text-capitalize me-1" }
const _hoisted_7 = { class: "h-100 d-none d-lg-flex flex-column text-start position-relative align-self-start align-self-md-center flex-item align-items-center border-start border-md-1" }
const _hoisted_8 = { class: "flex-item-container d-flex flex-column" }
const _hoisted_9 = { class: "body-strong text-primary-blue" }
const _hoisted_10 = { class: "body text-grey-900" }
const _hoisted_11 = { class: "flex-item-container d-flex flex-column" }
const _hoisted_12 = { class: "body-strong text-primary-blue" }
const _hoisted_13 = { class: "h-100 col-12 col-lg-2 ps-4 d-flex flex-column position-relative flex-item align-items-center border-start border-md-1" }
const _hoisted_14 = { class: "h-100 col-12 col-lg-2 d-flex flex-column align-items-end justify-content-center pe-md-3 position-relative" }
const _hoisted_15 = { class: "col-lg-3 col-12 d-flex justify-content-end h-100 align-items-center" }
const _hoisted_16 = { class: "h-100 d-flex col-md-10 col-12 align-items-center justify-content-center position-relative popup-accommodation-btn" }

import {
	computed,
	ComputedRef,
	onMounted,
	watch,
} from "vue";

//import store from "@/vue/planning/store/store";
import Prices from "@/vue/planning/components/common/prices.vue";
import SelectButton from "@/vue/planning/components/result/selectBtn.vue";
import Inclus from "@/vue/planning/components/result/prestation/inclus.vue";
import {
	getPrestCrossedPrice,
	getPrestTotalPrice,
	// getPrestPerPrice,
	getPrestMaxPromo,
	getMaxPromo,
} from "@/logic/pricesAndDiscount";
import responsesCache from "@/vue/planning/state/responsesCache";
import pricesLoadingSet from "@/vue/planning/state/pricesLoadingSet";
import currentCacheKey from "@/vue/planning/computed/currentCacheKey";
import PaymentCondition from "@/vue/planning/components/result/prestation/PaymentCondition.vue"
import displayPrice from "@/displayPrice/displayPrice"

// Config
import flightPackCode from "@/config/flightPackCode"
import trainPackCode from "@/config/trainPackCode"
import { airportCodeMap } from "@/config/airportCodeMap"
import { trainStationCodeMap } from "@/config/trainStationCodeMap"

import { useStore } from "vuex"
interface Props {
	variant: any;
}
interface Emits {
	(e: "select", id: string): void;
	(e: "clear", id: string): void;
	(
		e: "dropdownSelect",
		selectedData: { newSelected: number; id: string }
	): void;
	(e: "dropdownClick", obj: any): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PrestPopupVariantDefault',
  props: {
    variant: { default: {} }
  },
  emits: ["select", "clear", "dropdownSelect", "dropdownClick"],
  setup(__props: any, { emit: __emit }) {

const store = useStore();

const props = __props;
const emit = __emit;

// Helper function to get origin the same way getWiypPrice does
const getOriginForLookup = (packCode: string): string => {
	const rawOrigin = store.state.flightOrigin?.split("-")[0] || "";

	if (!packCode) return 'NA';

	if (flightPackCode.includes(packCode)) {
		return airportCodeMap.has(rawOrigin) ? rawOrigin : Array.from(airportCodeMap.keys())[0] || 'NA';
	} else if (trainPackCode.includes(packCode)) {
		return trainStationCodeMap.has(rawOrigin) ? rawOrigin : Array.from(trainStationCodeMap.keys())[0] || 'NA';
	}
	return 'NA';
};

// Create a computed property to track the specific wiypCall data for this variant
// This ensures reactivity when wiypCall changes
const wiypCallData = computed(() => {
	const origin = getOriginForLookup(store.state.packCode);
	const familyComposition = store.state.participants.join('-');
	const packageCode = store.state.packCode;
	const packageId = props.variant.prestId;
	
	return store.getters.getWiypCallByFamilyCompositionAndOriginAndPackageCodeAndId(
		familyComposition,
		origin,
		packageCode,
		packageId
	);
});

const accommodationOnly: ComputedRef<string | undefined> = computed(() => {
	const wiypData = wiypCallData.value;
	if(wiypData && wiypData.wiypPrices) {
		const accommodation = wiypData.wiypPrices.find((w: any) => w.prestId === props.variant.prestIdFusion);
		if(accommodation && accommodation.accomPriceWiyp) {
			return accommodation.accomPriceWiyp;
		}
	}

	if (store.state.packCode != 'HS' && store.state.selectedPrestIds && Object.keys(store.state.selectedPrestIds).length > 0) {
		try {
			const price = store.state.prestMaps.prices[store.state.packCode][props.variant.id].priceAccommodationOnly;
			if (price) {
				return displayPrice(parseInt(price) * 100, store.getters.locale) ?? undefined;
			}
		}
		catch (e) {
			console.error(e);
		}
	}
	return undefined;
});

const crossedPrice: ComputedRef<number> = computed(() => {
	const wiypData = wiypCallData.value;
	if(wiypData && wiypData.wiypPrices) {
		const crossed = wiypData.wiypPrices.find((w: any) => w.prestId === props.variant.prestIdFusion);
		if(crossed && crossed.publicPriceWiyp) {
			return crossed.publicPriceWiyp;
		}
	}
	if (!props.variant) return NaN;
	const pricesResponse = responsesCache.value.getResponse(
		"prices",
		currentCacheKey.value
	);
	return props.variant && getPrestCrossedPrice(props.variant, !!pricesResponse);
});

const perPrice: ComputedRef<number> = computed(() => {
	return NaN;
	// return props.variant && getPrestPerPrice(props.variant, this.participants.length)
});

const totalPrice: ComputedRef<number> = computed(() => {
	const wiypData = wiypCallData.value;
	if(wiypData && wiypData.wiypPrices) {
		const total = wiypData.wiypPrices.find((w: any) => w.prestId === props.variant.prestIdFusion);
		if(total && total.sellingPriceWiyp) {
			return total.sellingPriceWiyp;
		}
	}
	return props.variant && getPrestTotalPrice(props.variant);
});

const isDisabledPrest: ComputedRef<boolean> = computed(() => {
	return totalPrice.value <= 0;
});

const maxPromo: ComputedRef<number> = computed(() => {
	const wiypData = wiypCallData.value;
	if(wiypData && wiypData.wiypPrices) {
		const promoPrice = wiypData.wiypPrices.find((w: any) => w.prestId === props.variant.prestIdFusion);
		if(promoPrice && promoPrice.publicPriceWiyp && promoPrice.sellingPriceWiyp) {
			return getMaxPromo(Math.round(( promoPrice.publicPriceWiyp - promoPrice.sellingPriceWiyp) / promoPrice.publicPriceWiyp * 100));
		}
	}
	return props.variant && getPrestMaxPromo(props.variant);
});

// Watch wiypCall changes to ensure computed properties recompute
// Watching both the store state and the computed property ensures reactivity
watch(
	[
		() => store.state.wiypCall,
		() => store.state.participants,
		() => store.state.flightOrigin,
		() => store.state.packCode,
		() => props.variant,
	],
	() => {
		// Force recomputation by accessing the computed property
		wiypCallData.value;
	},
	{ deep: true }
);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(store).state.content.planner_prestationsDates), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(store).state.content.planner_datePickerFrom) + " " + _toDisplayString(_unref(store).state.dates.BeginDate), 1),
          _createElementVNode("span", null, _toDisplayString(_unref(store).state.content.planner_datePickerTill) + " " + _toDisplayString(_unref(store).state.dates.EndDate), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(store).state.content.planner_prestationsParticipants), 1),
        _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(store).state.participants.length) + " " + _toDisplayString(_unref(store).state.content.planner_prestationsPersons), 1)
      ])
    ]),
    _createElementVNode("div", {
      style: _normalizeStyle({
			visibility: _unref(store).state.packCode !== 'HS' ? 'visible' : 'hidden',
		}),
      class: "h-100 d-flex flex-column position-relative align-self-start align-self-md-center flex-item align-items-center border-start border-md-1"
    }, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(store).state.content.planner_prestationsInclude), 1),
        _createVNode(Inclus, {
          isDisplayPlaceholders: false,
          variant: props.variant
        }, null, 8, ["variant"])
      ])
    ], 4),
    _createElementVNode("div", _hoisted_13, [
      (props.variant?.paymentCondition !== undefined)
        ? (_openBlock(), _createBlock(PaymentCondition, {
            key: 0,
            paymentCondition: props.variant.paymentCondition,
            displayTitle: false,
            "cancellation-date": props.variant.cancelationUntil
          }, null, 8, ["paymentCondition", "cancellation-date"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(Prices, {
        isLoading: _unref(pricesLoadingSet).has(_unref(currentCacheKey)),
        packCode: props.variant.packCode,
        maxPromo: maxPromo.value,
        crossedPrice: crossedPrice.value,
        totalPrice: totalPrice.value,
        perPrice: perPrice.value,
        locale: _unref(store).getters.locale
      }, null, 8, ["isLoading", "packCode", "maxPromo", "crossedPrice", "totalPrice", "perPrice", "locale"])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createVNode(SelectButton, {
          accommodationOnly: accommodationOnly.value,
          variant: props.variant,
          locale: _unref(store).getters.locale,
          selectedQuantity: _unref(store).state.selectedPrestIds[props.variant.id],
          select_location: 'prestationPopup',
          disabled: isDisabledPrest.value,
          onSelectClick: _cache[0] || (_cache[0] = (id) => emit('select', id)),
          onDropdownClick: _cache[1] || (_cache[1] = (obj) => emit('dropdownClick', obj)),
          onClear: _cache[2] || (_cache[2] = (id) => emit('clear', id)),
          onDropdownSelect: _cache[3] || (_cache[3] = ({ newSelected, id }) => emit('dropdownSelect', { newSelected, id }))
        }, null, 8, ["accommodationOnly", "variant", "locale", "selectedQuantity", "disabled"])
      ])
    ])
  ]))
}
}

})